<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getSocialAccountList()"
          variant="primary"
          size="sm"
        )
      .form-group.col-12(v-if="isEditAccess")
        b-button(type="button" variant="info" size="sm" v-b-modal.addSocialAccount)
          i.fa.fa-lg.fa-plus
          span.ml-1 {{ $t("ui.combine.add_social_account") }}
  .card-body
    .row
      .col-md-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="15%")
                  span(:title="$t('ui.platform')") {{ $t('ui.platform') }}
                th(width="33%")
                  span(:title="$t('ui.link')") {{ $t("ui.link") }}
                th.text-right(width="15%")
                  span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                th.text-right(width="15%")
                  span(:title="$t('ui.modified_date')") {{ $t('ui.modified_date') }}
                th.text-center(width="7%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="socialList.length == 0")
                td(colspan="7").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in socialList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.social_platform") {{ item.social_platform }}
                td
                  span(:title="item.social_link") {{ item.social_link }}
                td.text-right
                  span(:title="item.created_by") {{ item.created_by }}
                  br
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                  br
                  span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
                td.text-center
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.actions.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEditSocialAccount(item)" :title="$t('ui.edit')")

    addsocialaccount(@clicked="addSocialAccount" @failed="handleFailed")
    editsocialaccount(ref="editsocialaccount" :item="editSelectedSocialAccount"  @clicked="afterEditSocialAccount" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addsocialaccount from "@/components/operator/addSocialAccount.vue";
import editsocialaccount from "@/components/operator/editSocialAccount.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addsocialaccount,
    editsocialaccount,
  },
  data: () => ({
    loading: false,
    socialList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedSocialAccount: null,
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    
    isEditAccess() {
      return this.$helpers.showActionButton("e_cms");
    }
  },
  mounted: function() {
    // this.getSocialAccountList();
  },
  methods: {
    refresh() {
      this.getSocialAccountList()
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_social_account_status_confirm", { name: item.social_platform }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.accountSocialStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        social_platform: item.social_platform,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getSocialAccountList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addSocialAccount: function() {
      this.getSocialAccountList();

      this.$helpers.showDialog(this.$t("ui.combine.add_social_account"), this.$t("message.success"), "success");
    },
    onEditSocialAccount(e) {
      this.editSelectedSocialAccount = e;
      this.$refs.editsocialaccount.$refs.editSocialAccount.show();
    },
    afterEditSocialAccount: function() {
      this.getSocialAccountList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_social_account"), this.$t("message.success"), "success");
    },
    getSocialAccountList: function() {
      let url = config.accountSocialListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.socialList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>